import PropTypes from 'prop-types'
import { useMsal } from '@azure/msal-react'
import { client } from '../API/epagAPI'
import { tokenRequest } from '../authConfig'
import { Text } from '../constants/TextConstants'
import { useEffect, useRef } from 'react'

export function RequestInterceptor(props) {
  const { instance, accounts: [account], inProgress } = useMsal()
  const interceptor = useRef(null)

  // NOTE: cleanup function so interceptor is reinitialzed upon re-render
  useEffect(() => {
    return () => {
      interceptor.current = null
    }
  }, [instance, account])

  // NOTE: we want to halt current render up until we have everything ready
  if (inProgress !== 'none') return null

  // NOTE: we are syncronously adding the interceptor so it is ready before all requests
  if (!interceptor.current) {
    interceptor.current = client.interceptors.request.use(async (config) => {
      if (!account) throw new Error(Text.NotSignedInError)

      const request = { ...tokenRequest, account }

      let accessToken

      try {
        ({ accessToken } = await instance.acquireTokenSilent(request))
      } catch {
        console.error(Text.FailedToAcquireTokenSilent);
        ({ accessToken } = await instance.acquireTokenRedirect(request))
      }

      if (!config.headers) config.headers = new Headers()

      config.headers.Authorization = accessToken

      return config
    })
  }

  return props.children
}

RequestInterceptor.propTypes = {
  children: PropTypes.node.isRequired
}
